export function backToLessonsHandlerFactory(productName, navigationEvent) {
  return () => navigationEvent(`/product/${productName}/lessons`)
}

export function unitSelectHandlerFactory(
  productName,
  navigationEvent,
  location,
) {
  return verb => (course, unitId) => {
    navigationEvent(
      `/product/${productName}/lessons/${verb}/${course}/${unitId}` +
        location.search,
    )
  }
}
